import { Navigate, useParams } from 'react-router-dom';

/** CNV-32: старые ссылки `/app/boards/shared/:token` продолжают открываться. */
export function LegacySharedRedirect() {
  const { token } = useParams();
  return <Navigate to={`/shared/${token ?? ''}`} replace />;
}
